exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".editContainer {\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n  direction: ltr;\n  text-align: left;\n  display: flex;\n  flex-direction: row;\n  padding-top: 10;\n  padding-bottom: 10;\n}\n.label {\n  color: rgba(61, 64, 78, 0.55);\n  margin-right: 16px;\n  font-size: 12px;\n  text-transform: uppercase;\n  font-weight: 600;\n  text-align: right;\n  flex: 1.5;\n}\n.inputWrapper {\n  flex: 4;\n}", ""]);

// exports
